import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { DealerService } from "src/app/core/services/dealer.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { PaymentProfile } from "src/app/shared/models/DTO/VenueFinance.dto";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-contract-finance-payment-profile-list",
	templateUrl: "./contract-finance-payment-profile-list.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class ContractFinancePaymentProfileListComponent implements OnInit {
	newPaymentProfile: boolean = false;

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		public dealerService: DealerService,
		public userService: UserService,
		private focuslink: FocuslinkService
	) {}

	ngOnInit(): void {}

	addNewProfile(profile: PaymentProfile) {
		if (!this.venueService.venueFinance.value.paymentProfiles) {
			this.venueService.venueFinance.value.paymentProfiles = [];
		}
		this.venueService.venueFinance.value.paymentProfiles.push(profile);
		this.venueService.venueFinance.next(this.venueService.venueFinance.value);
	}
	async setProfileDefault(profile: PaymentProfile) {
		this.app.loading(true);
		const body = {
			fw1__UseAsDefault__c: true,
		};

		await this.focuslink.contractFinancePaymentProfilePatch(this.venueService.venueKey, profile.recordId, body);
		this.app.loading(false);
		this.venueService.venueFinance.value.paymentProfiles.forEach((pp) => {
			if (pp.recordId !== profile.recordId) {
				pp.defaultProfile = false;
			} else {
				pp.defaultProfile = true;
			}
		});
		this.venueService.venueFinance.next(this.venueService.venueFinance.value);

		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Default payment updated.` });
	}
}
